import React from 'react';
import { Avatar, Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { Assignment, AttachMoney, EmojiEvents } from '@mui/icons-material';
import type { SchoolWithUserDto } from '@/global/api/gen/ts/SchoolWithUserDto';

interface Props {
    schoolInfo: SchoolWithUserDto | undefined
}

export function BalanceWidget({schoolInfo}: Props) {
    return (
        <Card
            sx={{
                borderRadius: '26px'
            }}
        >
            <CardContent
                sx={{padding: 3, display: 'flex', flexDirection: 'column', gap: 2}}
            >
                <Stack
                    flexDirection={'row'}
                    gap={4}
                >
                    <Card
                        sx={{
                            flexBasis: 1,
                            flexShrink: 0,
                            flexGrow: 1,
                            textAlign: 'center',
                            p: 3,
                            boxShadow: 2,
                            '&:hover': {boxShadow: 4}
                        }}
                    >
                        <CardContent
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{mb: 4}}
                            >
                                Текущий баланс
                            </Typography>

                            <Box sx={{mb: 4}}>
                                <Avatar
                                    sx={{
                                        bgcolor: 'primary.light',
                                        width: 64,
                                        height: 64,
                                        mx: 'auto'
                                    }}
                                >
                                    <AttachMoney sx={{fontSize: 32}}/>
                                </Avatar>
                            </Box>

                            <Typography
                                variant="h4"
                                color="success.main"
                                sx={{fontWeight: 'bold'}}
                            >
                                {schoolInfo?.balance ?? 0}
                                {' '}
                                ₸
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card
                        sx={{
                            flexBasis: 1,
                            flexShrink: 0,
                            flexGrow: 1,
                            textAlign: 'center',
                            p: 3,
                            boxShadow: 2,
                            '&:hover': {boxShadow: 4}
                        }}
                    >
                        <CardContent
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{mb: 4}}
                            >
                                Кешбек за Aitest
                            </Typography>

                            <Box sx={{mb: 4}}>
                                <Avatar
                                    sx={{
                                        bgcolor: 'primary.light',
                                        width: 64,
                                        height: 64,
                                        mx: 'auto'
                                    }}
                                >
                                    <Assignment sx={{fontSize: 32}}/>
                                </Avatar>
                            </Box>

                            <Typography
                                variant="h4"
                                color="success.main"
                                sx={{fontWeight: 'bold'}}
                            >
                                {schoolInfo?.cashback?.aitestPercent ?? 0}
                                {' '}
                                %
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card
                        sx={{
                            flexBasis: 1,
                            flexShrink: 0,
                            flexGrow: 1,
                            textAlign: 'center',
                            p: 3,
                            boxShadow: 2,
                            '&:hover': {boxShadow: 4}
                        }}
                    >
                        <CardContent
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{mb: 4}}
                            >
                                Кешбек за электронные свидетельства
                            </Typography>

                            <Box sx={{mb: 4}}>
                                <Avatar
                                    sx={{
                                        bgcolor: 'primary.light',
                                        width: 64,
                                        height: 64,
                                        mx: 'auto'
                                    }}
                                >
                                    <EmojiEvents sx={{fontSize: 32}}/>
                                </Avatar>
                            </Box>

                            <Typography
                                variant="h4"
                                color="success.main"
                                sx={{fontWeight: 'bold'}}
                            >
                                {schoolInfo?.cashback?.certificatePercent ?? 0}
                                {' '}
                                %
                            </Typography>
                        </CardContent>
                    </Card>
                </Stack>
            </CardContent>
        </Card>
    );
}

